import { IAppContext as CareerPageSettings } from 'wisestep-api';
import create, { SetState } from 'zustand';

export interface ICareerPageSettingStore {
  careerPageSettings: CareerPageSettings | null;
  setCareerPageSettings: (careerPageSettings: CareerPageSettings) => void;
}

export const careerPageSettingStore = create<ICareerPageSettingStore>(
  (set: SetState<ICareerPageSettingStore>) => ({
    careerPageSettings: null,
    setCareerPageSettings: (careerPageSettings: CareerPageSettings) =>
      set({ careerPageSettings: careerPageSettings }),
  })
);
